import React, { useCallback, useState } from 'react';
import { Alert, AlertTitle, Button, Tooltip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/pro-regular-svg-icons/faCopy';
import { oauth2ProxyCallbackPath } from '@loyalty/shared-common/gamification-api-client';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useApi } from '../../shared/api-client/ApiClientProvider';
import { useProgram } from '../../loyalty/ProgramContext';

export function RedirectUrisWhitelist(): React.ReactElement {
  const { program } = useProgram();
  const { t } = useTranslation();
  const { managerApi } = useApi();
  const [copied, setCopied] = useState(false);

  const programId = program?.id;
  const { data: embedData } = useQuery({
    queryKey: ['program', programId, 'embed'],
    queryFn: () => managerApi.getEmbed(programId as string),
    enabled: !!programId,
  });

  let redirectUri = '';
  if (embedData?.webview) {
    const url = new URL(embedData.webview);
    url.pathname = oauth2ProxyCallbackPath;
    redirectUri = url.toString().replace('https://', '');
  }

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(redirectUri);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }, [redirectUri]);

  const copyButton = (
    <Tooltip title={t('access-rule.login.redirecturi.copied')} open={copied}>
      <span>
        <Button variant="contained" color="secondary" onClick={handleCopy} disabled={!redirectUri}>
          <FontAwesomeIcon icon={faCopy} />
        </Button>
      </span>
    </Tooltip>
  );

  return (
    <Alert severity="info" style={{ marginTop: '20px' }} action={copyButton}>
      <AlertTitle>{t('access-rule.login.redirecturi.description')}</AlertTitle>
      {redirectUri}
    </Alert>
  );
}
